import { notifications } from '@mantine/notifications';
import { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';

import { ApiError } from 'src/types/api-error.types';

/**
 * Surfaces payer-related API errors under the paidBy field so a dead Save button becomes an
 * explanation. Shared by the creation and edition wrappers to keep the error mapping in one place.
 */
export const usePayerError = (form: { setFieldError: (field: string, error: string) => void }) => {
  const { t } = useTranslation();

  return (error: unknown) => {
    const code = (error as AxiosError<ApiError>)?.response?.data?.code;

    if (code === 'CONTACT_PAYER_CANNOT_BE_REIMBURSED') {
      form.setFieldError(
        'paidBy',
        t(
          'expense.form.contactPayerCannotBeReimbursed',
          'Un contact ne peut pas être remboursé par les copropriétaires. Choisissez un copropriétaire ou retirez la répartition.'
        )
      );
      return;
    }

    if (code === 'EXPENSE_PAYER_REQUIRED') {
      form.setFieldError(
        'paidBy',
        t('expense.form.payerRequired', 'Indiquez qui a payé ou encaissé pour enregistrer.')
      );
      return;
    }

    notifications.show({
      message: t('common.genericError', 'Une erreur est survenue. Merci de réessayer.'),
      color: 'red',
    });
  };
};
